import request, { requestFile } from 'utils/request'
import { getLocalizeStoreData } from 'utils/localizeStore'

const getFirstValue = (...values) =>
  values.find(value => value !== undefined && value !== null && value !== '') ?? ''

const normalizeProjectUser = projectUser => {
  const email = getFirstValue(projectUser.email, projectUser.user)

  return {
    ...projectUser,
    email,
    user: getFirstValue(projectUser.user, email),
    role: projectUser.role || ''
  }
}

const normalizeProjectDevice = device => {
  const deviceId = getFirstValue(device.deviceId, device.device_id, device._id)
  const mac = getFirstValue(device.mac, device.id_mac, device.MacAddressId, device.MacAddress)

  return {
    ...device,
    deviceId,
    device_id: getFirstValue(device.device_id, deviceId),
    id_mac: getFirstValue(device.id_mac, mac),
    mac,
    name: getFirstValue(device.name, device.Name)
  }
}

const normalizeProject = project => {
  const devices = Array.isArray(project.devices) ? project.devices : []
  const users = Array.isArray(project.users) ? project.users.map(normalizeProjectUser) : []
  const ownerEmail = getFirstValue(project.ownerEmail, project.owner_email)
  const ownerId = getFirstValue(project.ownerId, project.owner_id, project.CustomerId)
  const projectId = getFirstValue(project.projectId, project.project_id, project._id)
  const creationDate = getFirstValue(project.creationDate, project.creation_date)
  const deviceCount = getFirstValue(project.deviceCount, project.n_devices, devices.length)
  const userCount = getFirstValue(project.userCount, project.n_users, users.length)

  return {
    ...project,
    creationDate,
    creation_date: getFirstValue(project.creation_date, creationDate),
    deviceCount,
    devices,
    n_devices: getFirstValue(project.n_devices, deviceCount),
    n_users: getFirstValue(project.n_users, userCount),
    ownerEmail,
    ownerId,
    owner_email: getFirstValue(project.owner_email, ownerEmail),
    owner_id: getFirstValue(project.owner_id, ownerId),
    projectId,
    project_id: getFirstValue(project.project_id, projectId),
    userCount,
    users
  }
}

const normalizeDataList = (body, normalizer) => ({
  ...(body ?? {}),
  data: Array.isArray(body?.data) ? body.data.map(normalizer) : []
})

export function loadProjects(data) {
  return request('admin/projects', {
    method: 'POST',
    data
  }).then(([body]) => normalizeDataList(body, normalizeProject))
}

export function loadProjectsCount() {
  return request('admin/projects/count', {
    method: 'GET'
  }).then(([body]) => body)
}

export function loadProjectDevices(data) {
  return request('admin/projects/devices', {
    method: 'POST',
    data
  }).then(([body]) => normalizeDataList(body, normalizeProjectDevice))
}

export function loadCustomersList() {
  return request('admin/customers/email-list', {
    method: 'GET'
  }).then(([body]) => body ?? { data: [] })
}

export function transferProject(data) {
  return request('admin/projects/transfer', {
    method: 'PUT',
    data
  }).then(([body]) => body ?? {})
}

export function editProjectUsers(projectId, data) {
  const localizeStoreData = getLocalizeStoreData()

  return request(`admin/projects/${projectId}/edit`, {
    method: 'POST',
    data: {
      ...data,
      language: localizeStoreData?.lang || 'en'
    }
  }).then(([body]) => body ?? {})
}

export function downloadProjectInfo(projectId) {
  return requestFile(`admin/projects/${projectId}/info`, {
    method: 'POST',
    headers: {
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'content-type': 'application/json'
    }
  })
}
